<template>
  <a href="#"
     @click.prevent="handleClick"
     v-b-tooltip.hover="{ variant: 'base', placement: 'top', placement:'top', boundary:'viewport' }"
     :aria-label="tooltip ? tooltip : 'Download'"
     :title="tooltip ? tooltip : 'Download'"
     class="download-document-link"
  >
   <span v-html="downloadIconSvg" class="action-link-icon"></span>
  </a>
</template>

<script>

import { downloadIconSvg } from '@/assets/icons/downloadIcon'

export default {
  name: 'DownloadDocumentLink',
  props: {
    href: {
      type: String,
      required: true
    },
    tooltip: String
  },
  data () {
    return {
      downloadIconSvg
    }
  },
  methods: {
    handleClick () {
      this.$emit('download-click')
    }
  }
}
</script>

<style scoped lang="scss">
.download-document-link {
  line-height: 0;
  color: $body-color;
}
</style>
